/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OccupationUpdateApiModel { 
    id: number;
    name: string;
    valid: boolean;
    allRiskFactorExam: boolean;
}

